import { store } from '../store'

export default (to, from, next) => {
  console.log('view')
  if (store.getters.user && store.getters.userData.Access.viewAllJobs === true) {
    next()
  } else {
    next('/signin?returnURL=' + to.path)
  }
}



// WEBPACK FOOTER //
// ./src/router/ViewAllJobsGuard.js